module.exports = __webpack_public_path__ + "static/media/dob.e8c8f342.svg";